import React, { useState, useEffect } from "react";
import "../styles/Login.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { buildApiUrl, API_ENDPOINTS } from "../config/api";
import { apiRequest } from "../utils/apiUtils";
import PasswordStrengthChecklist from "../components/common/PasswordStrengthChecklist.jsx";

const ResetPassword = () => {
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [showPasswords, setShowPasswords] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setErrors({ general: "Token inválido o faltante" });
    }
  }, [token]);

  const validatePassword = (password) => {
    if (password.length < 8) {
      return "La contraseña debe tener al menos 8 caracteres";
    }
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
      return "Debe contener al menos: 1 mayúscula, 1 minúscula y 1 número";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage("");

    // Validaciones
    const newPasswordError = validatePassword(passwords.newPassword);
    if (newPasswordError) {
      setErrors({ newPassword: newPasswordError });
      return;
    }

    if (passwords.newPassword !== passwords.confirmPassword) {
      setErrors({ confirmPassword: "Las contraseñas no coinciden" });
      return;
    }

    if (!token) {
      setErrors({ general: "Token inválido" });
      return;
    }

    setIsLoading(true);

    try {
      await apiRequest(buildApiUrl(API_ENDPOINTS.resetPassword), {
        method: "POST",
        body: JSON.stringify({
          token,
          newPassword: passwords.newPassword,
        }),
      });

      setMessage(
        "Contraseña restablecida exitosamente. Redirigiendo al login...",
      );
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (error) {
      console.error("Error:", error);
      setErrors({
        general: error.message || "Error de conexión. Intenta nuevamente.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  return (
    <div className="login-page">
    <div className="login-container">
      <h2>Nueva Contraseña</h2>
      <p style={{ color: "var(--text-secondary)", fontSize: "11px", marginBottom: "20px" }}>
        Ingresa tu nueva contraseña
      </p>

      <form onSubmit={handleSubmit}>
        {errors.general && (
          <div
            style={{
              color: "var(--error-color)",
              textAlign: "center",
              marginBottom: "15px",
              fontSize: "11px",
            }}
          >
            {errors.general}
          </div>
        )}

        <div className="input-group">
          <label htmlFor="newPassword">Nueva Contraseña</label>
          <div className="password-container">
            <input
              className="password-input"
              type={showPasswords.newPassword ? "text" : "password"}
              value={passwords.newPassword}
              placeholder="Ingresa la nueva contraseña"
              onChange={(e) =>
                setPasswords({ ...passwords, newPassword: e.target.value })
              }
              disabled={isLoading}
            />
            <span
              className="password-toggle-icon"
              onClick={() => togglePasswordVisibility("newPassword")}
            >
              <i
                className={
                  showPasswords.newPassword ? "fas fa-eye-slash" : "fas fa-eye"
                }
              ></i>
            </span>
          </div>
          <p className={`error-message ${errors.newPassword ? "visible" : ""}`}>
            {errors.newPassword}
          </p>
          <PasswordStrengthChecklist password={passwords.newPassword} />
        </div>

        <div className="input-group">
          <label htmlFor="confirmPassword">Confirmar Contraseña</label>
          <div className="password-container">
            <input
              className="password-input"
              type={showPasswords.confirmPassword ? "text" : "password"}
              value={passwords.confirmPassword}
              placeholder="Confirma la nueva contraseña"
              onChange={(e) =>
                setPasswords({ ...passwords, confirmPassword: e.target.value })
              }
              disabled={isLoading}
            />
            <span
              className="password-toggle-icon"
              onClick={() => togglePasswordVisibility("confirmPassword")}
            >
              <i
                className={
                  showPasswords.confirmPassword
                    ? "fas fa-eye-slash"
                    : "fas fa-eye"
                }
              ></i>
            </span>
          </div>
          <p
            className={`error-message ${
              errors.confirmPassword ? "visible" : ""
            }`}
          >
            {errors.confirmPassword}
          </p>
        </div>

        {message && (
          <div
            style={{
              color: "var(--accent-color)",
              textAlign: "center",
              marginBottom: "15px",
              fontSize: "11px",
            }}
          >
            {message}
          </div>
        )}

        <button type="submit" disabled={isLoading || !token}>
          {isLoading ? "Restableciendo..." : "Restablecer Contraseña"}
        </button>
      </form>

      <div className="links">
        <button
          type="button"
          style={{
            background: "none",
            border: "none",
            color: "var(--accent-color)",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => navigate("/login")}
        >
          Volver al inicio de sesión
        </button>
      </div>
    </div>
    </div>
  );
};

export default ResetPassword;
